import { useSelector } from 'react-redux';
import useSendSnackbar from '../../../../../hooks/useSendSnackbar';
import { IReduxAppState } from '../../../../../reducers';
import { HTTPMethods } from '../../../../../yoello-lib/modules/API/API';
import APIExtensions from '../../../../../yoello-lib/modules/API2/APIDefs';
import { useAPIV2 } from '../../../../../yoello-lib/modules/API2/useAPIv2';

const useEditUser = ({
    venueId, 
    id, 
    users, 
    onClose
}: any) => {

    const user = users.find((user: any) => user.id === id);
    const merchant = useSelector((state: IReduxAppState) => state.merchant);

    const { sendSnackbar } = useSendSnackbar();

    const { apiData: permissions, isLoading }: any  = useAPIV2(APIExtensions.venueMerchant, {
        query: `${venueId}/merchants/${id}/permissions`,
      });
    
    const { callAPI: updatePermissions } = useAPIV2(APIExtensions.venueMerchant, {});

    const onSubmit = async (data: any) => {
        const formatedData = data.permissions
          .filter((permission: any) => permission.value)
          .map((permission: any) => ({ id: permission.id }));
    
        const res = await updatePermissions(HTTPMethods.PUT, {
          query: `${venueId}/merchants/${id}/permissions`,
          body: formatedData, 
        });
    
        if (res.isSuccessful) {
          sendSnackbar("userManagement.form.success", "success");
          onClose();
        } else {
          sendSnackbar("userManagement.form.failure", "error");
        }
      }

    return {
        user,
        permissions,
        isLoading,
        updatePermissions,
        onSubmit,
        isSelf: merchant?.id === user?.id
    }
}

export default useEditUser;